<app-appointment-picker
  [data]="data"
  [loading]="vm.loading"
  [disabled]="vm.submittingValue"
  (selectedSlot)="slotValue = $event"
/>

<input hidden [name]="vm.activeStep?.name!" [ngModel]="slotValue?.id" />

@if (vm.formSubmitted && !vm.formValid) {
  <section class="error mt-16">
    <i class="fa-light fa-circle-exclamation"></i>
    Select a time to continue.
  </section>
}

@if (vm.hasBringForwardOption) {
  <label class="bring-forward mt-16" for="bring_forward">
    <i
      class="fa-light mt-4"
      [class.fa-square-check]="vm.formValue?.[vm.bringForwardConfig?.name!]"
      [class.fa-square]="!vm.formValue?.[vm.bringForwardConfig?.name!]"
    ></i>

    <p class="label">
      {{ vm.bringForwardConfig!.title }}
    </p>
    <input
      type="checkbox"
      [name]="vm.bringForwardConfig?.name!"
      id="bring_forward"
      [ngModel]="vm.formValue?.[vm.bringForwardConfig?.name!]"
    />
  </label>
}
